import useToggle from '@/common/hooks/useToggle';
import { useIsMobile } from '@/hooks/use-is-mobile';
import { cn } from '@/lib/utils';
import { useEffect } from 'react';
import classes from './category-description-element.module.css';

export const CategoryDescriptionElement = ({
  categoryName,
  categoriesData,
}: {
  categoryName: string;
  categoriesData: any;
}) => {
  const { isMobile } = useIsMobile();

  const [descriptionVisible, toggleDescriptionVisible] = useToggle(false);

  const originalCategoryDescription =
    categoriesData && categoriesData?.categories?.items?.length
      ? categoriesData?.categories?.items?.[0]?.description
      : null;

  const categoryDescription =
    originalCategoryDescription &&
    originalCategoryDescription.indexOf(
      '<div data-content-type="html" data-appearance="default" data-element="main">',
    ) > -1
      ? originalCategoryDescription
          .replaceAll('<div data-content-type="html" data-appearance="default" data-element="main">', '')
          .replaceAll('</div>', '')
          .replaceAll('&gt;', '>')
          .replaceAll('&lt;', '<')
          .replaceAll('&amp;', '&')
      : originalCategoryDescription;

  const processedHTML = typeof categoryDescription === 'string' ? categoryDescription : String(categoryDescription);

  useEffect(() => {
    if (!isMobile) {
      toggleDescriptionVisible();
    }
  }, [isMobile, toggleDescriptionVisible]);

  if (!categoryName || !processedHTML || processedHTML === 'null') {
    return null;
  }

  return (
    <div className={cn('mt-[60px] px-[15px] lg_px-0')}>
      <div
        className='mb-[18px] flex cursor-pointer select-none items-center justify-center gap-x-2.5 text-center font-poppins font-[600] uppercase leading-[1.4] text-[#615956]'
        onClick={() => {
          toggleDescriptionVisible();
        }}
      >
        <h2>ABOUT {categoryName}</h2>
        <span className={descriptionVisible ? classes.arrowDown : classes.arrowRight}></span>
      </div>
      {descriptionVisible && (
        <div
          className='font-sans text-sm font-[500] leading-[1.4] text-[#615956] [&_h3]_text-[14px] [&_h3]_font-bold [&_ul]_list-inside [&_ul]_list-disc [&_ul]_pl-2.5'
          dangerouslySetInnerHTML={{
            __html: processedHTML,
          }}
        />
      )}
    </div>
  );
};
